import React from 'react';
import { CardNumberElement } from '@stripe/react-stripe-js';

import { VpStripeInput } from '../..';

export const StripeCardNumberInput = () => {
  return (
    <VpStripeInput stripeElement={CardNumberElement} placeholder="Card Number" name="cardNumber" />
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/stripe-elements/StripeCardNumberInput.jsx